export const compare = (a, b) => {
  if (a.primary_name < b.primary_name) {
    return -1;
  }
  if (a.primary_name > b.primary_name) {
    return 1;
  }
  return 0;
};